// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--iZ-vb";
export var logoFull = "index-module--logoFull--10DxL";
export var logo = "index-module--logo--2zmUG";
export var contact = "index-module--contact---Pci8";
export var li = "index-module--li--1lcrX";
export var address = "index-module--address--2mdgg";
export var followUs = "index-module--followUs--3rlQj";
export var icon = "index-module--icon--3UBzw";
export var logoContainer = "index-module--logoContainer--7yoKo";